export interface BrochureItem {
  id: string;
  title_el: string;
  title_en: string;
  description_el: string;
  description_en: string;
  keywords: string[];
  industry: string;
  category: 'process' | 'packaging' | 'automation' | 'lab' | 'support';
  file_type: 'PDF' | 'Datasheet' | 'Brochure' | 'Manual';
  file_url: string;
  featured?: boolean;
}

export const categoryLabels: Record<string, { el: string; en: string }> = {
  process: { el: 'Επεξεργασία', en: 'Process' },
  packaging: { el: 'Συσκευασία', en: 'Packaging' },
  automation: { el: 'Αυτοματισμός', en: 'Automation' },
  lab: { el: 'Εργαστήριο', en: 'Lab' },
  support: { el: 'Υποστήριξη', en: 'Support' },
};

export const industryLabels: Record<string, { el: string; en: string }> = {
  dairy: { el: 'Γαλακτοκομικά', en: 'Dairy' },
  beverage: { el: 'Ποτά', en: 'Beverages' },
  bakery: { el: 'Αρτοποιία', en: 'Bakery' },
  meat: { el: 'Κρέας & Ψάρι', en: 'Meat & Fish' },
  oils: { el: 'Έλαια & Λίπη', en: 'Oils & Fats' },
  spreads: { el: 'Αλείμματα', en: 'Spreads & Sauces' },
  fruit: { el: 'Φρούτα & Λαχανικά', en: 'Fruits & Vegetables' },
  'ready-meals': { el: 'Έτοιμα Γεύματα', en: 'Ready Meals' },
};

export const popularKeywords = [
  { el: 'Παστερίωση', en: 'Pasteurization' },
  { el: 'Ομογενοποίηση', en: 'Homogenization' },
  { el: 'Aseptic', en: 'Aseptic' },
  { el: 'UHT', en: 'UHT' },
  { el: 'Εμφιάλωση', en: 'Bottling' },
  { el: 'Παλετοποίηση', en: 'Palletizing' },
  { el: 'Ποιοτικός Έλεγχος', en: 'Quality Control' },
  { el: 'Ανάλυση Γάλακτος', en: 'Milk Analysis' },
  { el: 'CIP', en: 'CIP' },
  { el: 'Turnkey', en: 'Turnkey' },
];

export const brochures: BrochureItem[] = [
  {
    id: '1',
    title_el: 'SPX FLOW - Αντλίες & Βαλβίδες APV',
    title_en: 'SPX FLOW - Pumps & Valves APV',
    description_el: 'Φυγοκεντρικές αντλίες, αντλίες θετικής εκτόπισης, βαλβίδες Mixproof, Single Seat και Butterfly της σειράς APV.',
    description_en: 'Centrifugal pumps, positive displacement pumps, Mixproof, Single Seat and Butterfly valves from the APV range.',
    keywords: ['SPX FLOW', 'APV', 'pumps', 'valves', 'centrifugal', 'Mixproof', 'CIP'],
    industry: 'dairy',
    category: 'process',
    file_type: 'Datasheet',
    file_url: '/brochures/spx-flow-pumps-valves-apv.pdf',
    featured: true,
  },
  {
    id: '1b',
    title_el: 'SPX FLOW - Διαχωριστήρες & Ομογενοποιητές',
    title_en: 'SPX FLOW - Separators & Homogenisers',
    description_el: 'Διαχωριστήρες Seital αυτοκαθαριζόμενοι και ομογενοποιητές APV Gaulin/Rannie για γαλακτοκομικά.',
    description_en: 'Seital self-cleaning separators and APV Gaulin/Rannie homogenisers for dairy applications.',
    keywords: ['SPX FLOW', 'Seital', 'separator', 'homogeniser', 'APV Gaulin', 'Rannie'],
    industry: 'dairy',
    category: 'process',
    file_type: 'Datasheet',
    file_url: '/brochures/seital-separators-homogenisers.pdf',
    featured: true,
  },
  {
    id: '2',
    title_el: 'Λύσεις Επισκευασίας',
    title_en: 'Repackaging Solutions',
    description_el: 'Λύσεις επισκευασίας προϊόντων για τη βιομηχανία τροφίμων και ποτών.',
    description_en: 'Product repackaging solutions for the food and beverage industry.',
    keywords: ['repackaging', 'επισκευασία', 'συσκευασία'],
    industry: 'dairy',
    category: 'packaging',
    file_type: 'Brochure',
    file_url: '/brochures/lyseis-episkevasias.pdf',
  },
  {
    id: '3',
    title_el: 'Μηχανές Πλήρωσης',
    title_en: 'Filling Machines',
    description_el: 'Μηχανές πλήρωσης για υγρά και ημίρρευστα προϊόντα.',
    description_en: 'Filling machines for liquid and semi-liquid products.',
    keywords: ['filling', 'πλήρωση', 'εμφιάλωση'],
    industry: 'dairy',
    category: 'packaging',
    file_type: 'Brochure',
    file_url: '/brochures/mixanes-plirosis.pdf',
  },
  {
    id: '4',
    title_el: 'Freezer Παγωτού',
    title_en: 'Ice Cream Freezer',
    description_el: 'Συνεχούς ροής freezer για παραγωγή παγωτού.',
    description_en: 'Continuous flow freezers for ice cream production.',
    keywords: ['ice cream', 'παγωτό', 'freezer', 'continuous'],
    industry: 'dairy',
    category: 'process',
    file_type: 'Brochure',
    file_url: '/brochures/freezer-pagotou.pdf',
  },
];
